import React from "react";

export const ScatteredSnowShowersDayIcon = () => (
    <svg
        tabIndex={-1}
        focusable="false"
        className="svg-icon icon-weather"
        width="80px"
        height="80px"
        fill="none"
        viewBox="0 0 80 80"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g className="weather-fill" id="41" fill="#3F4447">
                <g transform="translate(4.000000, 9.000000)">
                    <path
                        d="M59.8,42.5 C64.6101126,42.5 68.5,38.6708191 68.5,33.9591837 C68.5,29.2475482 64.6101126,25.4183673 59.8,25.4183673 C59.028541,25.4183673 58.2717181,25.5165958 57.542218,25.7084205 C56.6703769,25.9376744 55.7946983,25.3516066 55.6742128,24.4582156 C55.106043,20.2452796 51.4297438,17.0510204 47.05,17.0510204 C46.9476122,17.0510204 46.8454636,17.0527505 46.7435806,17.0562024 C46.0191859,17.0807451 45.3808628,16.5838045 45.2269834,15.875517 C43.7963581,9.29052937 37.8485919,4.5 30.9,4.5 C23.3707983,4.5 17.0934185,10.1072567 16.328025,17.4017783 C16.2511413,18.1345121 15.6535009,18.7029345 14.9178361,18.7430245 C8.52355909,19.0914806 3.5,24.3011065 3.5,30.6122449 C3.5,37.1723436 8.91211925,42.5 15.6,42.5 L59.8,42.5 Z M59.8,22.4183673 C66.2564963,22.4183673 71.5,27.5800397 71.5,33.9591837 C71.5,40.3383277 66.2564963,45.5 59.8,45.5 L15.6,45.5 C7.26573556,45.5 0.5,38.8398521 0.5,30.6122449 C0.5,23.1099533 6.14080192,16.8675997 13.5172969,15.8649681 C14.9814981,7.64434846 22.2638241,1.5 30.9,1.5 C38.8479898,1.5 45.7195022,6.71939557 47.8640014,14.0786558 C52.8430382,14.4177308 57.0226049,17.8436669 58.3280855,22.508968 C58.8135631,22.4487839 59.3049038,22.4183673 59.8,22.4183673 Z"
                        fillRule="nonzero"
                    />
                    <rect
                        transform="translate(47.363005, 55.000000) rotate(45.000000) translate(-47.363005, -55.000000) "
                        x="45.8630047"
                        y="50"
                        width="3"
                        height="10"
                        rx="1.5"
                    />
                    <rect
                        transform="translate(47.363005, 55.000000) scale(-1, 1) rotate(45.000000) translate(-47.363005, -55.000000) "
                        x="45.8630047"
                        y="50"
                        width="3"
                        height="10"
                        rx="1.5"
                    />
                    <rect
                        transform="translate(25.363005, 55.000000) rotate(45.000000) translate(-25.363005, -55.000000) "
                        x="23.8630047"
                        y="50"
                        width="3"
                        height="10"
                        rx="1.5"
                    />
                    <rect
                        transform="translate(25.363005, 55.000000) scale(-1, 1) rotate(45.000000) translate(-25.363005, -55.000000) "
                        x="23.8630047"
                        y="50"
                        width="3"
                        height="10"
                        rx="1.5"
                    />
                    <path
                        d="M51.9125904,2.32658705 L52.4785722,4.98932219 C52.6508119,5.79964619 53.4473372,6.31691574 54.2576612,6.14467605 C55.0679852,5.97243637 55.5852547,5.17591112 55.413015,4.36558712 L54.8470332,1.70285198 C54.6747935,0.892527976 53.8782683,0.375258432 53.0679443,0.547498116 C52.2576203,0.7197378 51.7403507,1.51626305 51.9125904,2.32658705 Z"
                        fillRule="nonzero"
                    />
                    <path
                        d="M62.6575161,3.15043942 L61.1748876,5.43348708 C60.7236939,6.12826453 60.9211575,7.05725774 61.6159349,7.50845148 C62.3107124,7.95964523 63.2397056,7.76218163 63.6908993,7.06740419 L65.1735278,4.78435653 C65.6247216,4.08957908 65.427258,3.16058587 64.7324805,2.70939212 C64.0377031,2.25819837 63.1087099,2.45566198 62.6575161,3.15043942 Z"
                        fillRule="nonzero"
                    />
                    <path
                        d="M69.6727743,11.3308009 L67.0100392,11.8967827 C66.1997152,12.0690224 65.6824457,12.8655476 65.8546853,13.6758716 C66.026925,14.4861956 66.8234503,15.0034652 67.6337743,14.8312255 L70.2965094,14.2652437 C71.1068334,14.093004 71.624103,13.2964787 71.4518633,12.4861547 C71.2796236,11.6758307 70.4830984,11.1585612 69.6727743,11.3308009 Z"
                        fillRule="nonzero"
                    />
                    <path
                        d="M51.8700909,12.6962181 C52.5771307,11.4878392 53.7509515,10.6257264 55.1470612,10.3289741 C57.8481412,9.75484184 60.5032254,11.4790737 61.0773576,14.1801537 C61.4629589,15.9942652 60.8157935,17.8432103 59.4301009,19.0265839 C58.8001331,19.5645728 58.7255694,20.5113888 59.2635583,21.1413566 C59.8015472,21.7713244 60.7483632,21.845888 61.378331,21.3078991 C63.5923662,19.4171258 64.6283863,16.4572269 64.0118004,13.5564186 C63.0931888,9.23469058 58.8450541,6.47591967 54.5233261,7.39453132 C52.292762,7.86865236 50.4097713,9.25161508 49.2807636,11.1811655 C48.8623934,11.8961885 49.102878,12.8149852 49.817901,13.2333554 C50.532924,13.6517256 51.4517207,13.411241 51.8700909,12.6962181 Z"
                        fillRule="nonzero"
                    />
                </g>
            </g>
        </g>
    </svg>
);
